export default "__VITE_ASSET__3b50d8a3__"